import React from 'react';
import { Facebook, Github, Instagram, Twitter } from 'lucide-react';
import { Container, Logo } from './ui';
import SmartLink from './SmartLink';

const COLUMNS = [
  {
    title: 'Features',
    links: [
      { label: 'Peace of Mind', to: '/peace-of-mind' },
      { label: 'Transparency', to: '/group-controls' },
      { label: 'Group Controls', to: '/group-controls' },
      { label: 'Resolution Center', to: '/resolution-center' },
      { label: 'Group Discounts', to: '/group-discounts' },
      { label: 'AI Suggestions', to: '/extra-benefits' },
    ],
  },
  {
    title: 'Resources',
    links: [
      { label: 'Help Center', to: '/contact' },
      { label: 'Use Cases', to: '/#audience' },
      { label: 'Guides', to: '/#how-it-works' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About Us', to: '/about' },
      { label: 'Privacy Policy', to: '/privacy' },
      { label: 'Terms of Service', to: '/terms' },
      { label: 'Contact Us', to: '/contact' },
    ],
  },
];

const SOCIALS = [
  { icon: Facebook, label: 'Facebook', href: 'https://facebook.com' },
  { icon: Twitter, label: 'Twitter', href: 'https://twitter.com' },
  { icon: Instagram, label: 'Instagram', href: 'https://instagram.com' },
  { icon: Github, label: 'GitHub', href: 'https://github.com' },
];

const Footer = () => (
  <footer className="border-t border-white/[0.06] pb-12 pt-20">
    <Container>
      <div className="grid gap-12 md:grid-cols-5">
        <div className="md:col-span-2">
          <Logo />
          <p className="mt-4 max-w-xs leading-relaxed text-slate-400">
            Simplifying group finances with transparency, trust, and ease.
          </p>
          <div className="mt-6 flex gap-2">
            {SOCIALS.map(({ icon: Icon, label, href }) => (
              <SmartLink
                key={label}
                to={href}
                aria-label={label}
                className="flex h-11 w-11 items-center justify-center rounded-xl border border-white/[0.08] text-slate-400 transition-colors duration-200 hover:border-white/20 hover:text-white"
              >
                <Icon className="h-5 w-5" />
              </SmartLink>
            ))}
          </div>
        </div>

        {COLUMNS.map((col) => (
          <div key={col.title}>
            <h3 className="text-sm font-semibold text-white">{col.title}</h3>
            <ul className="mt-4 space-y-3">
              {col.links.map((link) => (
                <li key={link.label}>
                  <SmartLink to={link.to} className="text-sm text-slate-400 transition-colors duration-200 hover:text-white">
                    {link.label}
                  </SmartLink>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="mt-16 flex flex-col items-center justify-between gap-4 border-t border-white/[0.06] pt-8 text-sm text-slate-500 md:flex-row">
        <span>&copy; {new Date().getFullYear()} Groupmoney. All rights reserved.</span>
        <a href="mailto:support@groupmoney.app" className="transition-colors duration-200 hover:text-white">
          support@groupmoney.app
        </a>
      </div>
    </Container>
  </footer>
);

export default Footer;
